module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn efficiency"
  }, [_c('div', {
    class: {
      disabledbutton: _vm.loadingRemnants
    }
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "effect": "fade/zoom",
      "small": "",
      "title": ""
    },
    model: {
      value: (_vm.confirmModal),
      callback: function($$v) {
        _vm.confirmModal = $$v
      },
      expression: "confirmModal"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    slot: "modal-header"
  }, [_c('div', {
    staticStyle: {
      "font-size": "1.5em",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('statistic.expiration_date')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "card card-default filters card-modal"
  }, [_c('div', {
    staticClass: "card-modal"
  }, [(_vm.errorsByOrder.length) ? _c('div', {
    staticClass: "error"
  }, [_c('b', [_vm._v("Пожалуйста исправьте указанные ошибки:")]), _vm._v(" "), _c('ul', _vm._l((_vm.errorsByOrder), function(error, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(error))])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row date-filter"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('DatePicker', {
    staticClass: "datepicker",
    attrs: {
      "language": _vm.Storage.language,
      "placeholder": _vm.$t('statistic.expiration_date'),
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.expiration),
      callback: function($$v) {
        _vm.expiration = $$v
      },
      expression: "expiration"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-12 pad-top"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customs),
      expression: "customs"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.customs'),
      "name": "customs",
      "type": "text"
    },
    domProps: {
      "value": (_vm.customs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customs = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-12 pad-top"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.logistics),
      expression: "logistics"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.logistic'),
      "name": "customs",
      "type": "text"
    },
    domProps: {
      "value": (_vm.logistics)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.logistics = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 filter-buttons"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.addExpiration
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('verbs.save')) + "\n                            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    slot: "modal-footer"
  })]), _vm._v(" "), _c('ProductTabs'), _vm._v(" "), _c('RemnantsOrders', {
    attrs: {
      "rowRemnants": _vm.rowRemnants,
      "loading": _vm.loadingRemnants
    },
    on: {
      "changeVal": _vm.changeValRemnants
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card card-default filters",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "disabled": _vm.isLoad
    },
    on: {
      "click": function($event) {
        _vm.clickAdd()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-archive"
  }), _vm._v(" " + _vm._s(_vm.$t('verbs.add_product')) + "\n                    ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isBlock),
      expression: "isBlock"
    }],
    staticClass: "card card-default filters"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('form', {
    on: {
      "submit": _vm.checkForm
    }
  }, [(_vm.errors.length) ? _c('div', {
    staticClass: "error"
  }, [_c('b', [_vm._v("Пожалуйста исправьте указанные ошибки:")]), _vm._v(" "), _c('ul', _vm._l((_vm.errors), function(error, index) {
    return _c('li', {
      key: index
    }, [_vm._v(_vm._s(error))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.Storage.selectedCountry.id === -1) ? _c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.country),
      expression: "form.country"
    }],
    staticClass: "form-controls input",
    attrs: {
      "name": "status"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getGoodsAll]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": "dis"
    }
  }, [_vm._v(_vm._s(_vm.$t('statistic.country')))]), _vm._v(" "), _vm._l((_vm.Storage.countries), function(c) {
    return (c.id !== -1) ? _c('option', {
      domProps: {
        "value": c.id
      }
    }, [_vm._v(_vm._s(c.name))]) : _vm._e()
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.orders_count),
      expression: "form.orders_count"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.ordered'),
      "name": "orders_count",
      "type": "number"
    },
    domProps: {
      "value": (_vm.form.orders_count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.orders_count = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.price),
      expression: "form.price"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.price'),
      "name": "price",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.price = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.provider),
      expression: "form.provider"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.provider'),
      "name": "provider",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.provider)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.provider = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('DatePicker', {
    staticClass: "datepicker",
    attrs: {
      "language": _vm.Storage.language,
      "placeholder": _vm.$t('statistic.time'),
      "format": "yyyy-MM-dd",
      "name": "delivery_time"
    },
    model: {
      value: (_vm.form.delivery_time),
      callback: function($$v) {
        _vm.form.delivery_time = $$v
      },
      expression: "form.delivery_time"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-controls input",
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": "dis"
    }
  }, [_vm._v(_vm._s(_vm.$t('statistic.status')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Заказан")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Отгружен")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.comment),
      expression: "form.comment"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.comment'),
      "name": "comment",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.comment = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    ref: "file",
    staticClass: "form-control input files",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFilesUpload($event.target.name, $event.target.files)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "clear-on-select": false,
      "close-on-select": false,
      "hide-selected": false,
      "multiple": false,
      "options": _vm.storageGoodsAll,
      "placeholder": _vm.$t('statistic.products'),
      "preserve-search": true,
      "searchable": true,
      "label": "name",
      "name": "product",
      "track-by": "name"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n                                                    " + _vm._s(props.option.name) + " "), (_vm.Storage.developMode) ? _c('b', [_vm._v("(" + _vm._s(props.option.alias) + ")")]) : _vm._e()])])]
      }
    }]),
    model: {
      value: (_vm.form.product),
      callback: function($$v) {
        _vm.form.product = $$v
      },
      expression: "form.product"
    }
  })], 1)])]), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "clear-on-select": false,
      "close-on-select": false,
      "hide-selected": false,
      "multiple": false,
      "options": _vm.Storage.goods,
      "placeholder": _vm.$t('statistic.products'),
      "preserve-search": true,
      "searchable": true,
      "label": "name",
      "name": "product",
      "track-by": "name"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n                                                    " + _vm._s(props.option.name) + " "), (_vm.Storage.developMode) ? _c('b', [_vm._v("(" + _vm._s(props.option.alias) + ")")]) : _vm._e()])])]
      }
    }]),
    model: {
      value: (_vm.form.product),
      callback: function($$v) {
        _vm.form.product = $$v
      },
      expression: "form.product"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.orders_count),
      expression: "form.orders_count"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.ordered'),
      "name": "orders_count",
      "type": "number"
    },
    domProps: {
      "value": (_vm.form.orders_count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.orders_count = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.price),
      expression: "form.price"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.price'),
      "name": "price",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.price = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.provider),
      expression: "form.provider"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.provider'),
      "name": "provider",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.provider)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.provider = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('DatePicker', {
    staticClass: "datepicker",
    attrs: {
      "language": _vm.Storage.language,
      "placeholder": _vm.$t('statistic.time'),
      "format": "yyyy-MM-dd",
      "name": "delivery_time"
    },
    model: {
      value: (_vm.form.delivery_time),
      callback: function($$v) {
        _vm.form.delivery_time = $$v
      },
      expression: "form.delivery_time"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-controls input",
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.form.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "selected": "",
      "value": "dis"
    }
  }, [_vm._v(_vm._s(_vm.$t('statistic.status')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Заказан")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Отгружен")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row date-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.comment),
      expression: "form.comment"
    }],
    staticClass: "form-control input",
    attrs: {
      "placeholder": _vm.$t('statistic.comment'),
      "name": "comment",
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.comment = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "row pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('input', {
    ref: "file",
    staticClass: "form-control input files",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFilesUpload($event.target.name, $event.target.files)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 pad-top"
  }, [_c('button', {
    staticClass: "btn btn-primary float-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Отправить")])])])])])]), _vm._v(" "), _c('ProductOrders', {
    attrs: {
      "loading": _vm.loadingProduct,
      "rowsOrder": _vm.rowsOrder
    },
    on: {
      "addReceipt": _vm.addReceipt,
      "changeVal": _vm.changeVal,
      "deleteChange": _vm.deleteChange,
      "download": _vm.download,
      "downloadAll": _vm.downloadAll,
      "uploadImage": _vm.uploadImageOrder
    }
  }), _vm._v(" "), _c('ReceiptOrders', {
    attrs: {
      "loading": _vm.loadingProduct,
      "rowsReceipt": _vm.rowsReceipt
    },
    on: {
      "changeVal": _vm.changeVal,
      "downloadAllReceipt": _vm.downloadAllReceipt,
      "uploadImageReceipt": _vm.uploadImageReceipt,
      "downloadPdfReceipt": _vm.downloadPdfReceipt
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary float-right",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Отправить")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c9b1ada"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/product/Product.vue
// module id = 581
// module chunks = 0